// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1G6uD","modalFooterButton":"ModalNotes_modalFooterButton__p69_o"};